import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Paper,
  Typography,
  Button,
  Menu,
  MenuItem,
  Divider,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import LensIcon from '@mui/icons-material/Lens';
import CloseIcon from '@mui/icons-material/Close';
import RemoveIcon from '@mui/icons-material/Remove';

import CanvasJSReact from '../../../utils/canvas/canvasjs.react';
const CanvasJSChart = CanvasJSReact.CanvasJSChart;

const generateDataPoints = (noOfDps) => {
  var xVal = 1,
    yVal = 100;
  var dps = [];
  for (var i = 0; i < noOfDps; i++) {
    yVal = yVal + Math.round(5 + Math.random() * (-5 - 5));
    dps.push({ x: xVal, y: yVal });
    xVal++;
  }
  return dps;
};

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: '30px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2, 3),
  },
  button: {
    marginRight: theme.spacing(1),
    padding: theme.spacing(0, 1),
    borderColor: '#d2dae1',
    borderRadius: '50px',
    color: '#000',
    fontSize: '12px',
    '&:hover': {
      borderColor: '#9fa5ab',
    },
  },
  chartBody: {
    marginTop: theme.spacing(3),
    height: 400,
  },
  navButton: {
    margin: theme.spacing(0.5),
    width: 'fit-content',
    minWidth: 'unset',
    height: 35,
    fontSize: '14px',
    fontWeight: 'bold',
    borderRadius: '50px',
    textTransform: 'none',
    backgroundColor: '#794b6b',
    borderColor: '#794b6b',
    '&:hover': {
      backgroundColor: '#66445c',
    },
    '& svg': {
      marginRight: theme.spacing(0.5),
      fontSize: '14px',
    },
  },
  actions: {
    width: 'fit-content',
    padding: theme.spacing(1),
    backgroundColor: '#FFF',
    borderRadius: 50,
    margin: '30px auto',
  },
  appendix: {
    display: 'flex',
    margin: '50px auto',
    width: 'fit-content',
    gap: 100,
  },
  text: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '12px',
    color: '#586065',
    '& svg': {
      marginRight: '8px',
      color: '#586065',
      fontSize: 12,
    },
  },
  newfirmed: {
    margin: theme.spacing(0.125),
    padding: theme.spacing(0, 1),
    backgroundColor: '#a604b5',
    color: '#FFF',
    borderRadius: '50px',
  },
  firming: {
    margin: theme.spacing(0.125),
    padding: theme.spacing(0, 1),
    color: '#FFF',
    backgroundColor: 'green',
    borderRadius: '50px',
  },
  personalbest: {
    margin: theme.spacing(0.125),
    color: 'blue',
  },
}));

const Timing = () => {
  const navigate = useNavigate();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  const options = {
    theme: 'dark1', // "light1", "dark1", "dark2"
    animationEnabled: true,
    zoomEnabled: true,
    data: [
      {
        type: 'area',
        dataPoints: generateDataPoints(500),
      },
    ],
  };

  return (
    <div className={classes.root}>
      <Paper elevation={0} className={classes.header}>
        <Button
          variant='outlined'
          className={classes.button}
          onClick={() => navigate(-1)}
        >
          <NavigateBeforeIcon />
          Back
        </Button>
        <Typography>{' / Daily Timings for Practice Cards'}</Typography>

        <Button
          variant='outlined'
          className={classes.button}
          sx={{ marginLeft: 'auto' }}
          onClick={(e) => setAnchorEl(e.currentTarget)}
        >
          More
          <ArrowDropDownIcon />
        </Button>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
          className={classes.menu}
        >
          <MenuItem
            onClick={() => {
              setAnchorEl(null);
              navigate('/sets/1/celeration');
            }}
          >
            Daily Chart
          </MenuItem>
          <MenuItem
            onClick={() => {
              setAnchorEl(null);
              navigate('/sets');
            }}
          >
            Fluency Cards
          </MenuItem>
          <Divider />
          <MenuItem>Help</MenuItem>
        </Menu>
      </Paper>

      <Paper elevation={0} className={classes.chartBody}>
        <p>Chart here</p>
        <CanvasJSChart options={options} />
      </Paper>

      <div className={classes.actions}>
        <Button variant='contained' className={classes.navButton}>
          <ArrowBackIosNewIcon />
        </Button>
        <Button variant='contained' className={classes.navButton}>
          Now
        </Button>
        <Button variant='contained' className={classes.navButton}>
          <ArrowForwardIosIcon />
        </Button>
      </div>

      <div className={classes.appendix}>
        <div>
          <Typography className={classes.text}>
            <span className={classes.newfirmed}>NEWly firmed deck</span>
          </Typography>
          <Typography className={classes.text}>
            <span className={classes.firming}>FIRMing deck</span>
          </Typography>
          <Typography className={classes.text}>
            <span className={classes.personalbest}>__</span>
            Personal Best
          </Typography>
        </div>
        <div>
          <Typography className={classes.text}>
            <LensIcon />
            Counter per minute
          </Typography>
          <Typography className={classes.text}>
            <CloseIcon />
            Errors per minute
          </Typography>
          <Typography className={classes.text}>
            <RemoveIcon />
            Timings (Record) Floor
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default Timing;
